import * as React from "react";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { SEARCH_FILTERS_GROUP } from "../../../../../../../config/search/filters/groupsConfig";
import { RootState, store } from "../../../../../../../store/redux/store";
import { NomenclatureAutocompleteFilter } from "@duosoftbg/nacid-components";
import { globalMessageTypesThunk } from "../../../../../../../store/redux/slice/AppData/globalMessageTypes";

const GlobalMessageTypesFilter = () => {
  const group = SEARCH_FILTERS_GROUP.GLOBAL_MESSAGE_MANAGEMENT;

  const thunkState = useAppSelector((state) => {
    return state.AppData.globalMessageTypes;
  });

  const getPreviousStateOptionFn = () => {
    const state = store.getState() as RootState;
    const typeId = state.SearchData.portalSearchTable[group].filtersData.globalMessageType;
    const options = state.AppData.globalMessageTypes.data;
    return options.find((element) => element.id === typeId);
  };

  return (
    <NomenclatureAutocompleteFilter
      filter={"globalMessageType"}
      thunkFn={globalMessageTypesThunk}
      thunkState={thunkState}
      getPreviousStateOptionFn={getPreviousStateOptionFn}
    />
  );
};

export default GlobalMessageTypesFilter;
